let OPTIONS = {
  // 应用信息
  name: "",
  version: "",
  context: "", // TODO
  appid: "",
  // 服务配置
  server: {
    // 基础URL
    baseURL: "",
    // 请求超时
    timeout: 30 * 1000,
    // Axios
    axios: {
      // 创建配置
      config: {},
    },
    // 对象存储
    oss: {
      // URL
      baseURL: "",
      // 上传 URL
      uploadURL: "/api/oss/uploadFile",
    },
  },
  // 路由配置
  router: {
    // 白名单
    ignores: [
      "/login"
    ],
    // 登录路径
    loginPath: "/login",
    // 已登录路径
    loginedPath: "/",
    // 包装组件
    wrapper: "",
    // 路由规则
    routes: [],
  },
};

export function getOptions() {
  return OPTIONS;
}

export function getServer() {
  return getOptions().server;
}

export function getServerOSS() {
  return getServer().oss;
}

export function getRouter() {
  return getOptions().router;
}

export function initOptions(options) {
  OPTIONS = options;
}
